
import { MachineComponentModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { machineComponentsStore } from '@/libs/machine-components/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import MachineComponentDialog from '../components/MachineComponentDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        MachineComponentDialog,
    },
})
export default class MachineComponents extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('machineComponents.code'), value: 'code', align: 'left', sortable: false },
            { text: this.$i18n.t('machineComponents.name'), value: 'name', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: MachineComponentDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return machineComponentsStore.useGetter(CrudGetter.Pending);
    }

    get items(): MachineComponentModel[] {
        return [...machineComponentsStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...machineComponentsStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        machineComponentsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<MachineComponentModel>(
            [
                { field: 'code', index: 1, order: 'asc' },
                { field: 'name', index: 2, order: 'asc' },
            ],
            this.getFilters()
        );
    }

    open(item: MachineComponentModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }
}
